import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Guam: Country = {
    identifier: "Guam",
    name: "Guam",
    countryCode: "GU",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇬🇺",
    svgPath: "m 881.11175,425.6204 -0.119,0.005 -0.103,-0.096 -0.036,-0.065 -0.002,-0.33 0.396,-0.281 0.13,-0.274 0.109,0.022 0.096,0.045 0.088,0.082 -0.453,0.457 z",
}
